import React from 'react';
import {saveAs} from 'file-saver';
import * as XLSX from 'xlsx';

import Button from '../Button/Button';

const ExcelDownloadButton = ({data, fileName, headers, topRow, openModal, readyToDownload}) => {
    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);
        if (topRow) {
            const maxLength = headers[0]?.length || 0;
            const paddedTopRow = [...topRow, ...Array(Math.max(0, maxLength - topRow.length)).fill('')];
            XLSX.utils.sheet_add_aoa(worksheet, [paddedTopRow], {origin: 'A1'});
        }
        XLSX.utils.sheet_add_aoa(worksheet, headers, {origin: topRow ? 'A2' : 'A1'});
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        const blob = new Blob([excelBuffer], {type: 'application/octet-stream'});
        saveAs(blob, `${fileName}.xlsx`);
    };

    return (
        <Button onClick={data.length === 2000 && !readyToDownload ? openModal : exportToExcel} size={'small'}>Descargar</Button>
    );
};

export default ExcelDownloadButton;
